// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getAllProgressionAnalyses } from "../../api";
import { ProgressionAnalysisType } from "../../types";

export const useProgressionAnalyses = (
  clinicId: string | undefined,
  clinicTimezone: string | null,
  patientId: string | undefined
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ProgressionAnalysisType>>({
    queryKey: ["progression-analyses", clinicId, patientId],
    queryFn: async () => {
      if (!clinicId || !patientId) throw new Error();
      const token = await getToken();
      return getAllProgressionAnalyses(
        token,
        clinicId,
        patientId,
        clinicTimezone
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
